export default {
    // 中
    zhCN: {
        year: '年',
        month: '月',
        category_name: '分类名称',
        number_of_cases: '案例数量',
        percentage_of_cases: '案例占比',
        reporting_organization_name: '上报组织名称',
        full_query: '全量查询',
        day: '天',
    },
    // 英
    enUS: {
        year: 'Year',
        month: 'Month',
        category_name: 'Category name',
        number_of_cases: 'Total cases',
        percentage_of_cases: 'Percentage of cases',
        reporting_organization_name: 'Reporting organization name',
        full_query: 'Full query',
        day: 'Day',
    },
    // 德
    deDE: {
        year: 'Jahr',
        month: 'Monat',
        category_name: 'Kategoriename',
        number_of_cases: 'Anzahl der Fälle',
        percentage_of_cases: 'Prozentsatz der Fälle',
        reporting_organization_name: 'Name der meldenden Organisation',
        full_query: 'Vollständige Abfrage',
        day: 'Tag',
    },
    // 法
    frFR: {
        year: 'Année',
        month: 'Mois',
        category_name: 'Nom de catégorie',
        number_of_cases: 'Total cas',
        percentage_of_cases: 'Pourcentage de cas',
        reporting_organization_name: 'Nom de l\'organisation de signalement',
        full_query: 'Requête complète',
        day: 'Jours',
    },
    // 意大利
    itIT: {
        year: 'Anno',
        month: 'Mese',
        category_name: 'Nome Categoria',
        number_of_cases: 'Numero di Casi',
        percentage_of_cases: 'Percentuale di Casi',
        reporting_organization_name: 'Nome Organizzazione Segnalante',
        full_query: 'Query Completa',
        day: 'Giorno',
    },
    // 荷兰
    nlNL: {
        year: 'Jaar',
        month: 'Maand',
        category_name: 'Categorie naam',
        number_of_cases: 'Aantal gevallen',
        percentage_of_cases: 'Percentage van gevallen',
        reporting_organization_name: 'Meldende organisatie naam',
        full_query: 'Volledige query',
        day: 'Dag',
    },
    // 越南
    viVN: {
        year: 'Năm',
        month: 'Tháng',
        category_name: 'Tên danh mục',
        number_of_cases: 'Tổng số trường hợp',
        percentage_of_cases: 'Phần trăm số trường hợp',
        reporting_organization_name: 'Tên tổ chức báo cáo',
        full_query: 'Tra cứu toàn bộ',
        day: 'Ngày',
    },
    // 西班牙
    esES: {
        year: 'Año',
        month: 'Mes',
        category_name: 'Nombre de la categoría',
        number_of_cases: 'Número de casos',
        percentage_of_cases: 'Porcentaje de casos',
        reporting_organization_name: 'Nombre de la organización informante',
        full_query: 'Consulta completa',
        day: 'Días',
    },
    // 葡萄牙
    ptBR: {
        year: 'Ano',
        month: 'Mês',
        category_name: 'Nome da categoria',
        number_of_cases: 'Número de casos',
        percentage_of_cases: 'Percentagem de casos',
        reporting_organization_name: 'Nome da organização de relatório',
        full_query: 'Consulta completa',
        day: 'Dia',
    },
    // 波兰
    plPL: {
        year: 'Rok',
        month: 'Mesiąc',
        category_name: 'Nazwa kategorii',
        number_of_cases: 'Liczba spraw',
        percentage_of_cases: 'Odsetek spraw',
        reporting_organization_name: 'Nazwa organizacji raportującej',
        full_query: 'Pełne zapytanie',
        day: 'Dzień',
    },
    // 土耳其
    trTR: {
        year: 'Yıl',
        month: 'Ay',
        category_name: 'Kategori adı',
        number_of_cases: 'Toplam Dosyalar',
        percentage_of_cases: 'Dosyaların yüzdesi',
        reporting_organization_name: 'Bildirim organizasyonu adı',
        full_query: 'Tam sorgulama',
        day: 'gün',
    },
    // 捷克语
    csCZ: {
        year: 'Rok',
        month: 'Měsíc',
        category_name: 'Název Kategorie',
        number_of_cases: 'Celkový počet případů',
        percentage_of_cases: 'Procento případů',
        reporting_organization_name: 'Název ohlašující společnosti',
        full_query: 'Úplný dotaz',
        day: 'Den',
    },
    // 匈牙利语
    huHU: {
        year: 'Év',
        month: 'Hónap',
        category_name: 'Kategória neve',
        number_of_cases: 'Összes eset',
        percentage_of_cases: 'Esetek százaléka',
        reporting_organization_name: 'Jelentő szervezet neve',
        full_query: 'Teljes lekérdezés',
        day: 'Nap',
    },
    // 俄罗斯语
    ruRU: {
        year: 'Год',
        month: 'Месяц',
        category_name: 'Название категории',
        number_of_cases: 'Количество случаев',
        percentage_of_cases: 'Процент случаев',
        reporting_organization_name: 'Название отчетной организации',
        full_query: 'Полный запрос',
        day: 'День',
    },
    // 沙特阿拉伯 (阿拉伯语)
    arSA: {
        year: 'سنة',
        month: 'شهر',
        category_name: 'اسم التصنيف',
        number_of_cases: 'عدد الحالات',
        percentage_of_cases: 'نسبة الحالات',
        reporting_organization_name: 'اسم المنظمة المبلغة',
        full_query: 'استعلام كامل',
        day: 'يوم',
    },
    // 保加利亚语
    bgBG: {
        year: 'Година',
        month: 'Месец',
        category_name: 'Име на категорията',
        number_of_cases: 'Брой случаи',
        percentage_of_cases: 'Процент случаи',
        reporting_organization_name: 'Име на докладващата организация',
        full_query: 'Пълен заявкa',
        day: 'Ден',
    },
    // 丹麦语
    daDK: {
        year: 'År',
        month: 'Måned',
        category_name: 'Kategorinavn',
        number_of_cases: 'Antal sager',
        percentage_of_cases: 'Procentdel sager',
        reporting_organization_name: 'Rapporterende organisationsnavn',
        full_query: 'Fuld forespørgsel',
        day: 'Dag',
    },
    // 芬兰语
    fiFI: {
        year: 'Vuosi',
        month: 'Kuukausi',
        category_name: 'Luokan nimi',
        number_of_cases: 'Tapauksien määrä',
        percentage_of_cases: 'Tapauksien osuus',
        reporting_organization_name: 'Ilmoittavan organisaation nimi',
        full_query: 'Koko tietojoukko',
        day: 'Päivä',
    },
    // 繁体中文（台湾）
    zhTW: {
        year: '年',
        month: '月',
        category_name: '分類名稱',
        number_of_cases: '案例數量',
        percentage_of_cases: '案例佔比',
        reporting_organization_name: '上報組織名稱',
        full_query: '全量查詢',
        day: '天',
    },
    // 克罗地亚语
    hrHR: {
        year: 'Godina',
        month: 'Mjesec',
        category_name: 'Naziv kategorije',
        number_of_cases: 'Broj slučajeva',
        percentage_of_cases: 'Postotak slučajeva',
        reporting_organization_name: 'Naziv prijavljujuće organizacije',
        full_query: 'Potpuno upit',
        day: 'Dan',
    },
    // 拉脱维亚语
    lvLV: {
        year: 'Gads',
        month: 'Mēnesis',
        category_name: 'Kategorijas nosaukums',
        number_of_cases: 'Gadījumu skaits',
        percentage_of_cases: 'Gadījumu procents',
        reporting_organization_name: 'Ziņojošās organizācijas nosaukums',
        full_query: 'Pilns vaicājums',
        day: 'Diena',
    },
    // 立陶宛语
    ltLT: {
        year: 'Metai',
        month: 'Mėnuo',
        category_name: 'Kategorijos pavadinimas',
        number_of_cases: 'Atvejų skaičius',
        percentage_of_cases: 'Atvejų dalis',
        reporting_organization_name: 'Pranešančios organizacijos pavadinimas',
        full_query: 'Visų duomenų užklausa',
        day: 'Diena',
    },
    // 罗马尼亚语
    roRO: {
        year: 'An',
        month: 'Lună',
        category_name: 'Numele categoriei',
        number_of_cases: 'Numărul de cazuri',
        percentage_of_cases: 'Procentul cazurilor',
        reporting_organization_name: 'Numele organizației raportoare',
        full_query: 'Interogare completă',
        day: 'Zi',
    },
    // 挪威博克马尔语
    nbNO: {
        year: 'År',
        month: 'Måned',
        category_name: 'Kategorinavn',
        number_of_cases: 'Antall saker',
        percentage_of_cases: 'Prosentandel saker',
        reporting_organization_name: 'Rapporterende organisasjonsnavn',
        full_query: 'Full spørring',
        day: 'Dag',
    },
    // 葡萄牙语（巴西）
    ptBX: {
        year: 'Ano',
        month: 'Mês',
        category_name: 'Nome da categoria',
        number_of_cases: 'Quantidade de casos',
        percentage_of_cases: 'Percentual de casos',
        reporting_organization_name: 'Nome da organização reportante',
        full_query: 'Consulta completa',
        day: 'Dia',
    },
    // 瑞典语
    svSE: {
        year: 'År',
        month: 'Månad',
        category_name: 'Kategorinamn',
        number_of_cases: 'Antal fall',
        percentage_of_cases: 'Andel fall (%)',
        reporting_organization_name: 'Rapporterande organisationsnamn',
        full_query: 'Fullständig förfrågan',
        day: 'Dag',
    },
    // 斯洛伐克语
    skSK: {
        year: 'Rok',
        month: 'Mesiac',
        category_name: 'Názov kategórie',
        number_of_cases: 'Počet prípadov',
        percentage_of_cases: 'Percento prípadov',
        reporting_organization_name: 'Názov nahlásenej organizácie',
        full_query: 'Kompletný dopyt',
        day: 'Deň',
    },
    // 斯洛文尼亚语
    slSI: {
        year: 'Leto',
        month: 'Mesec',
        category_name: 'Ime kategorije',
        number_of_cases: 'Število primerov',
        percentage_of_cases: 'Odstotek primerov',
        reporting_organization_name: 'Ime poročajoče organizacije',
        full_query: 'Polna poizvedba',
        day: 'Dan',
    },
    // 泰语
    thTH: {
        year: 'ปี',
        month: 'เดือน',
        category_name: 'ชื่อหมวดหมู่',
        number_of_cases: 'จำนวนกรณี',
        percentage_of_cases: 'สัดส่วนของกรณี',
        reporting_organization_name: 'ชื่อองค์กรที่รายงาน',
        full_query: 'สอบถามข้อมูลทั้งหมด',
        day: 'วัน',
    },
    // 乌克兰语
    ukUA: {
        year: 'Рік',
        month: 'Місяць',
        category_name: 'Назва категорії',
        number_of_cases: 'Кількість випадків',
        percentage_of_cases: 'Частка випадків',
        reporting_organization_name: 'Назва організації, що повідомляє',
        full_query: 'Повний запит',
        day: 'День',
    },
    // 希腊语
    elGR: {
        year: 'Έτος',
        month: 'Μήνας',
        category_name: 'Όνομα κατηγορίας',
        number_of_cases: 'Αριθμός περιστατικών',
        percentage_of_cases: 'Ποσοστό περιστατικών',
        reporting_organization_name: 'Όνομα του οργανισμού που υπέβαλε την αναφορά',
        full_query: 'Πλήρης ερώτημα',
        day: 'Ημέρα',
    },
    // 爱沙尼亚语
    etEE: {
        year: 'Aasta',
        month: 'Kuu',
        category_name: 'Kategooria nimi',
        number_of_cases: 'Juhtumite arv',
        percentage_of_cases: 'Juhtumite protsent',
        reporting_organization_name: 'Teavitava organisatsiooni nimi',
        full_query: 'Täielik päring',
        day: 'Päev',
    },
    // 哈萨克语
    kkKZ: {
        year: 'Жыл',
        month: 'Ай',
        category_name: 'Санат атауы',
        number_of_cases: 'Жағдайлар саны',
        percentage_of_cases: 'Жағдайлар пайызы',
        reporting_organization_name: 'Есеп беретін ұйымның атауы',
        full_query: 'Толық сұрау',
        day: 'Күн',
    },
    // 希伯来语
    heIL: {
        year: 'שנה',
        month: 'חודש',
        category_name: 'שם הקטגוריה',
        number_of_cases: 'כמות המקרים',
        percentage_of_cases: 'אחוז המקרים',
        reporting_organization_name: 'שם הארגון המדווח',
        full_query: 'שאילתה מלאה',
        day: 'יום',
    },
};
